import { render } from "./permissionSelector.vue?vue&type=template&id=179d4c65&scoped=true"
import script from "./permissionSelector.vue?vue&type=script&lang=js"
export * from "./permissionSelector.vue?vue&type=script&lang=js"

import "./permissionSelector.vue?vue&type=style&index=0&id=179d4c65&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179d4c65"]])

export default __exports__